import React, { FunctionComponent, ReactElement } from "react"
import { LinkMeta } from "@client-hub/shared/react/hooks/links"
import { Navigator, NavItem } from "@icanbwell/ui-toolkit"
import { useLocation, useNavigate } from "react-router-dom"
import { styled } from "@mui/material"
import ROUTES from "@client-hub/shared/constants/routes"
import { CollapsibleDrawer } from "./CollapsibleDrawer"
import { SIDEBAR_WIDTH } from "constants/sizing"

export type Props = {
  links: LinkMeta[]
}

const StyledNavigator = styled(Navigator)(
  ({
    theme: {
      palette: { grey },
      spacing,
    },
  }) => ({
    minHeight: "360px",
    zIndex: "1",
    width: SIDEBAR_WIDTH,
    maxWidth: "initial",
    paddingTop: spacing(4),

    "& li:first-child": {
      borderBottom: `2px solid ${grey[300]}`,
      marginBottom: "10px",
      paddingBottom: "10px",
    },
  }),
)

const Sidebar: FunctionComponent<Props> = ({ links }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const currentPath = location?.pathname
  const filteredLinks = links.filter((link) => currentPath?.includes(link.to as string))

  return filteredLinks.length ? (
    <CollapsibleDrawer>
      <StyledNavigator data-testid="navigator">
        {filteredLinks.map(({ subLinks, label, icon, to }) => {
          return subLinks ? (
            subLinks.map(({ label, icon, to }) => (
              <NavItem
                key={label}
                label={label}
                icon={icon as ReactElement}
                isActive={to !== ROUTES.BASE && currentPath.includes(to as string)}
                onClick={() => navigate(to as string)}
                aria-label={label}
              />
            ))
          ) : (
            <NavItem
              key={label}
              label={label}
              icon={icon as ReactElement}
              isActive={currentPath.includes(to as string)}
              onClick={() => navigate(to as string)}
              aria-label={label}
            />
          )
        })}
      </StyledNavigator>
    </CollapsibleDrawer>
  ) : null
}

export default Sidebar
